
import { isString, map } from 'lodash';
import { User } from '../user/user';

export class DocumentField {
  text: string
  isBoolean: boolean
  comment: string

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export class Document {
  id: string
  name: string
  target: string
  filename: string
  fields: DocumentField[]

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  temporary_file_id: string

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if(this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if(this.fields) {
      this.fields = map(this.fields, f => new DocumentField(f));
    }
  }

  get valid():boolean {
    // name
    if(!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if(trimmedName.length > 200) {
      return false;
    }

    if(trimmedName.length === 0) {
      return false;
    }

    // target
    if(!isString(this.target)) {
      return false;
    }

    let trimmedTarget = this.target.trim();

    if(trimmedTarget.length === 0) {
      return false;
    }

    // temporary_file_id
    if(!this.id) {
      if(!isString(this.temporary_file_id)) {
        return false;
      }

      let trimmedTempFileId = this.temporary_file_id.trim();

      if(trimmedTempFileId.length === 0) {
        return false;
      }
    }

    return true;
  }

  toCreateDocumentInput() {
    return {
      name: this.name,
      target: this.target,
      temporary_file_id: this.temporary_file_id
    };
  }

  toUpdateDocumentInput() {
    return {
      name: this.name,
      target: this.target,
      temporary_file_id: this.temporary_file_id
    };
  }
}
